"use strict";

angular.module("vendor").config(function($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state("home", {
        url: "/home",
        templateUrl: require("vendor/sections/home/home.html"),
        css: require("vendor/sections/home/home.useable.css"),
        controller: "SectionHome",
        controllerAs: "homeCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Together business is made easier");
        }
    })
    .state("registration", {
        url: "/registration?supplier&token&groupInvite",
        templateUrl: require("vendor/sections/auth/registration.html"),
        css: [
            require("bower_components/angular-tree-control/css/tree-control.css"),
            require("bower_components/angular-tree-control/css/tree-control-attribute.css"),
            require("assets/css/tree-wegotrade.css")
        ],
        controller: "SectionRegistration",
        controllerAs: "registerCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Registration");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title registration");
            },
            description: function(gettextCatalog) {
                return gettextCatalog.getString("meta description registration");
            },
            keywords: function(gettextCatalog) {
                return gettextCatalog.getString("meta keywords registration");
            }
        }
    })
    .state("catalogsList", {
        url: "/catalogsList?search",
        templateUrl: require("vendor/sections/catalog/catalog-list.html"),
        css: require("vendor/sections/catalog/catalog-list.useable.css"),
        controller: "SectionCatalogsList",
        controllerAs: "CatalogsListCtrl",
        authenticate: true,
        defaultSearchSection: "catalogsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Catalogs");
        }
    })
    .state("catalogEdit", {
        url: "/catalogEdit/:id",
        templateUrl: require("vendor/sections/catalog/catalog-edit.html"),
        css: require("vendor/sections/catalog/catalog-edit.useable.css"),
        controller: "SectionCatalogEdit",
        controllerAs: "CatalogEditCtrl",
        authenticate: true,
        params: {
            forceModalRedirect: null
        },
        defaultSearchSection: "catalogsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Catalogs");
        }
    })
    .state("productsList", {
        url: "/productsList?search&page",
        templateUrl: require("vendor/sections/product/product-list.html"),
        controller: "SectionProductsList",
        controllerAs: "productsListCtrl",
        authenticate: true,
        defaultSearchSection: "productsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Products");
        }
    })
    .state("productEdit", {
        url: "/productEdit/:id",
        template: "<ui-view />",
        css: [
            require("bower_components/angular-tree-control/css/tree-control.css"),
            require("bower_components/angular-tree-control/css/tree-control-attribute.css"),
            require("assets/css/tree-wegotrade.css")
        ],
        authenticate: true,
        defaultSearchSection: "productsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Products");
        },
        resolve: {
            catalogFormData: function(Workflow) {
                return Workflow.getFormData("catalogEdit");
            }
        },
        onEnter: function($state, $stateParams, $timeout, catalogFormData) {
            if ($stateParams.id) {
                _.defer(function() {
                    $state.go("productEdit.edit");
                });
            }
            else {
                if (catalogFormData) {
                    _.defer(function() {
                        $state.go("productEdit.edit");
                    });
                }
                else {
                    _.defer(function() {
                        $state.go("productEdit.add");
                    });
                }
            }
        }
    })
    .state("productEdit.add", {
        url: "",
        templateUrl: require("vendor/sections/product/product-add.html"),
        controller: "SectionProductAdd",
        controllerAs: "productAddCtrl",
        defaultSearchSection: "productsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Products");
        }
    })
    .state("productEdit.edit", {
        url: "",
        templateUrl: require("vendor/sections/product/product-edit.html"),
        controller: "SectionProductEdit",
        controllerAs: "productEditCtrl",
        defaultSearchSection: "productsList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Products");
        }
    })
    .state("ordersList", {
        url: "/ordersList?product&search&ordering&page&status&creation_date_start&creation_date_end&contact_type&order_modified&order_cancelled&delivery_date_start&delivery_date_end",
        templateUrl: require("vendor/sections/order/order-list.html"),
        controller: "SectionOrdersList",
        controllerAs: "orderListCtrl",
        authenticate: true,
        defaultSearchSection: "ordersList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Orders");
        }
    })
    .state("orderDetails", {
        url: "/orderDetails/:id?referer",
        templateUrl: require("vendor/sections/order/order-detail.html"),
        controller: "SectionOrderDetails",
        controllerAs: "orderDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "ordersList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Orders");
        }
    })
    .state("orderLog", {
        url: "/orderLog?order",
        controller: "SectionOrderLog",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Orders");
        }
    })
    .state("invoiceList", {
        url: "/invoices?search&ordering&page&status&invoice_date_start&invoice_date_end&customer_ids&payment_due_date_start&payment_due_date_end&status_date_start&status_date_end&is_overdue",
        templateUrl: require("vendor/sections/invoice/invoice-list.html"),
        controller: "InvoiceListController",
        controllerAs: "invoiceListCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoices");
        }
    })
    .state("invoiceDetails", {
        url: "/invoice/:id",
        templateUrl: require("vendor/sections/invoice/invoice-detail.html"),
        controller: "InvoiceDetailsController",
        controllerAs: "invoiceDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoices");
        }
    })
    .state("invoiceAttachments", {
        url: "/invoice/:id/attachments",
        templateUrl: require("vendor/sections/invoice-attachment/invoice-attachment.html"),
        controller: "InvoiceAttachmentController",
        controllerAs: "invoiceAttachmentCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoices");
        }
    })
    .state("paymentList", {
        url: "/payments?search&page&ordering&status&status_date_start&status_date_end&method",
        templateUrl: require("vendor/sections/payment/payment-list.html"),
        controller: "PaymentListController",
        controllerAs: "paymentListCtrl",
        authenticate: true,
        defaultSearchSection: "paymentList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payments");
        }
    })
    .state("paymentDetails", {
        url: "/payment/:id",
        templateUrl: require("vendor/sections/payment/payment-details.html"),
        controller: "PaymentDetailsController",
        controllerAs: "paymentDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "paymentList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payments");
        }
    })
    .state("customerManagement", {
        url: "/customers/manage?search&page&ordering&status&tags&status_date_start&status_date_end&zones&sales_rep_status",
        templateUrl: require("vendor/sections/customer/customer-manage.html"),
        controller: "CustomerManagementController",
        controllerAs: "customerManagementCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customerToApprove", {
        url: "/customers/to-approve?search&page&ordering&zones",
        templateUrl: require("vendor/sections/customer/customer-to-approve.html"),
        controller: "CustomerToApproveController",
        controllerAs: "customerToApproveCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customerSendReminder", {
        url: "/customers/send-reminder?search&page&ordering&status&tags&status_date_start&status_date_end&zones",
        templateUrl: require("vendor/sections/customer/customer-send-reminder.html"),
        controller: "CustomerSendReminderController",
        controllerAs: "customerSendReminderCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customerSendNotification", {
        url: "/customers/send-notification?search&page&ordering&status&tags&status_date_start&status_date_end&zones",
        templateUrl: require("vendor/sections/customer/customer-send-notification.html"),
        controller: "CustomerSendNotificationController",
        controllerAs: "customerSendNotificationCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customerFinancial", {
        url: "/customers/financial?search&page&ordering&status&tags&status_date_start&status_date_end&zones&sales_rep_status&financial_status",
        templateUrl: require("vendor/sections/customer/customer-financial.html"),
        controller: "CustomerFinancialController",
        controllerAs: "customerFinancialCtrl",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customer", {
        url: "/customerEdit/:id",
        template: "<ui-view />",
        authenticate: true,
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        },
        resolve: {
            catalogFormData: function(Workflow) {
                return Workflow.getFormData("catalogEdit");
            }
        },
        onEnter: function($state, $stateParams, $timeout, catalogFormData) {
            if ($stateParams.id) {
                _.defer(function() {
                    $state.go("customer.edit");
                });
            }
            else {
                if (catalogFormData) {
                    _.defer(function() {
                        $state.go("customer.edit");
                    });
                }
                else {
                    _.defer(function() {
                        $state.go("customer.add");
                    });
                }
            }
        }
    })
    .state("customer.add", {
        url: "",
        templateUrl: require("vendor/sections/customer/customer-add.html"),
        controller: "SectionCustomerAdd",
        controllerAs: "customerAddCtrl",
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("customer.edit", {
        url: "",
        templateUrl: require("vendor/sections/customer/customer-edit.html"),
        controller: "SectionCustomerEdit",
        controllerAs: "customerEditCtrl",
        defaultSearchSection: "customerManagement",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        }
    })
    .state("salesRepresentativesList", {
        url: "/sales-representatives?search&page",
        templateUrl: require("vendor/sections/sale-representative/sale-representative-list.html"),
        controller: "SalesRepresentativesListController",
        controllerAs: "salesRepresentativesListCtrl",
        authenticate: true,
        defaultSearchSection: "salesRepresentativesList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Sales representatives");
        }
    })
    .state("salesRepresentativesEdit", {
        url: "/sales-representatives/:id",
        templateUrl: require("vendor/sections/sale-representative/sale-representative-edit.html"),
        controller: "SalesRepresentativesEditController",
        controllerAs: "SalesRepresentativesEditCtrl",
        authenticate: true,
        params: {
            forceModalRedirect: null
        },
        defaultSearchSection: "salesRepresentativesList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Sales representatives");
        }
    })
    .state("importDocumentList", {
        url: "/import-document-list?search",
        templateUrl: require("vendor/sections/import/import-document-list.html"),
        controller: "SectionImportDocumentList",
        controllerAs: "importDocumentListCtrl",
        authenticate: true,
        defaultSearchSection: "importLogList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Imports");
        }
    })
    .state("importLogList", {
        url: "/import-log-list?search&document",
        templateUrl: require("vendor/sections/import/import-log-list.html"),
        controller: "SectionImportLogList",
        controllerAs: "importLogListCtrl",
        authenticate: true,
        defaultSearchSection: "importLogList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Imports");
        }
    })
    .state("import", {
        url: "/import",
        templateUrl: require("vendor/sections/import/import.html"),
        controller: "SectionImport",
        controllerAs: "importCtrl",
        authenticate: true,
        defaultSearchSection: "importLogList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Imports");
        }
    })
    .state("resetPassword", {
        url: "/reset-password?username&code",
        templateUrl: require("core/reset-password/reset-password.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "ResetPassword",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Reset Password");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title reset password");
            },
            description: function(gettextCatalog) {
                return gettextCatalog.getString("meta description reset password");
            },
            keywords: function(gettextCatalog) {
                return gettextCatalog.getString("meta keywords reset password");
            }
        }
    })
    .state("requestResetCode", {
        url: "/request-reset-code",
        templateUrl: require("core/reset-password/request-code.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "RequestPasswordResetCode",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Request Reset Code");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title request reset code");
            },
            description: function(gettextCatalog) {
                return gettextCatalog.getString("meta description request reset code");
            },
            keywords: function(gettextCatalog) {
                return gettextCatalog.getString("meta keywords request reset code");
            }
        }
    })
    .state("forgotUsername", {
        url: "/forgot-username",
        templateUrl: require("core/reset-password/forgot-username.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "ForgotUsername",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("ForgotUsername");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title forgot username");
            },
            description: function(gettextCatalog) {
                return gettextCatalog.getString("meta description forgot username");
            },
            keywords: function(gettextCatalog) {
                return gettextCatalog.getString("meta keywords forgot username");
            }
        }
    })
    .state("profile-edit", {
        url: "/profile-edit",
        templateUrl: require("core/profile/profile.html"),
        controller: "Profile",
        controllerAs: "profileCtrl",
        authenticate: true,
        allowAll: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Profile");
        }
    })
    .state("company-edit", {
        url: "/company-edit?qbo_success&qbo_error&qbo_revoke&qbo_guide",
        templateUrl: require("vendor/sections/auth/vendor.html"),
        controller: "SupplierEdit",
        controllerAs: "supplierEditCtrl",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Company");
        }
    })
    .state("quickBooksIntegrationRevoke", {
        url: "/integration/quickbooks/revoke",
        templateUrl: require("vendor/sections/integration/quickbooks/quickbooks-revoke.html"),
        controller: "QuickBooksRevokeController",
        authenticate: false,
        hideBackButton: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("QuickBooks Integration Revoke");
        }
    })
    .state("paymentSettings", {
        url: "/payment-settings",
        templateUrl: require("vendor/sections/payment-settings/payment-settings.html"),
        controller: "VendorPaymentSettingsController",
        controllerAs: "paymentSettingsCtrl",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payment settings");
        }
    })
    .state("support", {
        url: "/support?document",
        onEnter: function($http, $stateParams, appConfig) {
            var support_url;
            if ($stateParams.document)
                support_url = encodeURIComponent($stateParams.document);
            $http({
                method: "GET",
                url: appConfig.API_SERVER + "/auth/vendor/support/",
                params: {
                    return_to: support_url
                }
            }).then(
                function(response) {
                    window.location = response.data;
                }
            );
        }
    })
    .state("terms-of-service", {
        url: "/terms-of-service",
        templateUrl: require("core/terms-of-service/terms-of-service.html"),
        controller: "TermsOfService",
        authenticate: true,
        allowAll: true,
        hideBackButton: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Terms of service");
        }
    })
    .state("supportVendorList", {
        url: "/support/vendors?search",
        templateUrl: require("vendor/sections/support/support-vendor-list.html"),
        controller: "SupportVendorListController",
        controllerAs: "supportVendorListCtrl",
        authenticate: true,
        impersonatorOnly: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Vendor list");
        }
    })
    .state("reports", {
        url: "/reports",
        templateUrl: require("vendor/sections/report/report.html"),
        controller: "ReportController",
        controllerAs: "reportCtrl",
        authenticate: true,
        allowAll: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Reports");
        }
    })
    .state("login", {
        url: "/login?order&state&referer&username&groupInvite&qbo_guide",
        templateUrl: require("vendor/sections/auth/login.html"),
        css: require("vendor/sections/auth/login.useable.css"),
        controller: "SectionLogin",
        authenticate: false,
        hideBackButton: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Login");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title login");
            },
            description: function(gettextCatalog) {
                return gettextCatalog.getString("meta description login");
            },
            keywords: function(gettextCatalog) {
                return gettextCatalog.getString("meta keywords login");
            }
        }
    })
    .state("shippingRateList", {
        url: "/shipping-rates",
        templateUrl: require("vendor/sections/shipping-rate/shipping-rate-list.html"),
        controller: "ShippingRateListController",
        controllerAs: "shippingRateListCtrl",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Shipping Rates");
        }
    }).state("shippingRateEdit", {
        url: "/shipping-rate/:id",
        templateUrl: require("vendor/sections/shipping-rate/shipping-rate-edit.html"),
        controller: "ShippingRateEditController",
        controllerAs: "shippingRateEditCtrl",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Shipping Rates");
        }
    })
    .state("404", {
        url: "/404",
        templateUrl: require("core/http-error-response/not-found.html"),
        controller: "NotFoundController",
        controllerAs: "notFoundCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Page not found");
        }
    })
    .state("502", {
        url: "/maintenance",
        templateUrl: require("core/http-error-response/maintenance.html"),
        controller: "MaintenanceController",
        controllerAs: "maintenanceCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Maintenance in progress");
        }
    });

    $urlRouterProvider.when("/", "home").otherwise("404");
})

.run(function(
    $rootScope, $state, $cookies, CssUseableActivator, $http, $location, UserService, gettextCatalog, appConfig
) {
    UserService.initUser();
    CssUseableActivator.init();

    var catalogPermissionRestrictiedSections = [
        "catalogsList",
        "catalogEdit",
        "import"
    ]

    function validateState(event, toState, toParams, fromState, fromParams, user) {
        if (!user) {
            if (toState.name != "login") {
                event.preventDefault();
                $state.go("login");
            }
            return;
        }

        if (toState.name !== "terms-of-service" && user.have_to_agree_tos) {
            event.preventDefault();
            $state.go("terms-of-service");
            return;
        }
        else if (user.info.is_impersonator && toState.name !== "supportVendorList" && !toState.allowAll && !user.vendor) {
            event.preventDefault();
            $state.go("supportVendorList");
            return;
        }
        else if (
            (!user.info.is_impersonator && toState.impersonatorOnly)
            || (toState.name === "terms-of-service" && !user.have_to_agree_tos)
        ) {
            event.preventDefault();
            if (fromState.name !== "") {
                $state.go(fromState, fromParams);
                return;
            }
            else {
                $state.go("home");
                return;
            }
        }
        else if (user.info && !user.info.can_manage_catalog && toState.name === "home") {
            event.preventDefault();
            $state.go("customerManagement");
            return;
        }
        else if (user.info && !user.info.can_manage_catalog && catalogPermissionRestrictiedSections.indexOf(toState.name) !== -1) {
            event.preventDefault();
            $state.go("404");
            return;
        }
        else if (toState.name === "login" && toParams.qbo_guide) {
            event.preventDefault();
            $state.go("company-edit", {"qbo_guide": 1});
            return;
        }
        else if (toState.name === "login") {
            event.preventDefault();
            $state.go("home");
            return;
        }
    }

    $rootScope.UpdateCurrentNumbers = function() {
        if (UserService.isLoggedIn()) {
            $http({
                method: "get",
                url: appConfig.API_SERVER + "/catalog/vendor/current-number/",
                ignoreLoadingBar: true
            }).then(function(response) {
                $rootScope.CurrentNumbers = response.data;
                $rootScope.$broadcast("currentNumbersUpdated", $rootScope.CurrentNumbers);
            });
        }
        else {
            $rootScope.CurrentNumbers = [];
        }
    };

    $rootScope.$on("UserUpdated", function() {
        $rootScope.UpdateCurrentNumbers();
    });

    $rootScope.$on("$locationChangeSuccess", function() {
        $rootScope.previousLocation = $rootScope.actualLocation;
        $rootScope.actualLocation = $location.absUrl();
    });

    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeStart to " + toState.to + "- fired when the transition begins. toState,toParams : \n", toState, toParams);
        $rootScope.fromState = {};
        $rootScope.fromParams = {};
        var isModalOpened = ($(".modal").data("bs.modal") || {}).isShown;

        if (toState.name === "502" ) {
            return;
        }
        else if (isModalOpened && !toParams.forceModalRedirect) {
            event.preventDefault();
            $state.go(fromState, fromParams);
            return;
        }
        else if (UserService.isLoggedIn()) {
            if ($rootScope.user) {
                validateState(event, toState, toParams, fromState, fromParams, $rootScope.user);
            }
            else {
                UserService.isUserFetched().then(function onSuccess(user) {
                    validateState(event, toState, toParams, fromState, fromParams, user);
                });
            }
            $rootScope.fromState = fromState;
            $rootScope.fromParams = fromParams;
            return;
        }
        else if (toState.authenticate) {
            event.preventDefault();
            $state.go("login");
            return;
        }
    });

    // make debugging a hell of a lot easier
    $rootScope.$on("$stateChangeError", console.log.bind(console));

    $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeError - fired when an error occurs during transition.");
        console.log(arguments);
    });

    $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
        // Google Analytics(ga) - to support Single Page App - https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
        gtag('set', 'page_path',  "/" + toState.name);
        gtag('event', 'page_view');

        console.log("$stateChangeSuccess to " + toState.name + "- fired once the state transition is complete.");
        $rootScope.CurrentStateControllerName = toState.controller;
        if (!toState.impersonatorOnly && !toState.allowAll) {
            $rootScope.UpdateCurrentNumbers();
        }

        if (!toState.authenticate) {
            if (toState.meta) {
                $rootScope.meta.pageTitle = toState.meta.title(gettextCatalog);
                $rootScope.meta.description = toState.meta.description(gettextCatalog);
                $rootScope.meta.keywords = toState.meta.keywords(gettextCatalog);
            }
            else {
                $rootScope.meta.pageTitle = gettextCatalog.getString("default meta title");
                $rootScope.meta.description = gettextCatalog.getString("default meta description");
                $rootScope.meta.keywords = gettextCatalog.getString("default meta keywords");
            }
        }
    });

    $rootScope.$on("$viewContentLoaded", function(event) {
        console.log("$viewContentLoaded - fired after dom rendered", event);
    });

    $rootScope.$on("$stateNotFound", function(event, unfoundState, fromState, fromParams) {
        console.log("$stateNotFound " + unfoundState.to + "  - fired when a state cannot be found by its name.");
        console.log(unfoundState, fromState, fromParams);
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/vendor.route.js
// module id = 724
// module chunks = 0